import { Text, Box, Heading } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CellValue } from 'react-table';

import { DesktopTable as Table } from 'components/Table';
import ExportMenuFiltered from 'containers/Reports/shared/ExportMenuFiltered';
import { useUserObject } from 'store/useUserStore';
import { formatDistanceUnit, formatYearMonthDayTime } from 'utils/format';

const FlaggedEntriesFilterTable: React.FC<{ data: any; dateRange: Array<any> }> = ({ data, dateRange }) => {
  const { t } = useTranslation(['common', 'reports']);
  const userStore = useUserObject();

  const columns = useMemo(
    () => [
      {
        Header: t('common:name'),
        accessor: 'name',
      },
      ...(userStore?.companyInfo?.show_employee_id ? [{ Header: t('common:userID'), accessor: 'employee_id' }] : []),
      {
        Header: t('common:jobOrTask'),
        accessor: 'job',
        Cell: (data: CellValue) => (
          <>
            {data.value || '- '}
            {data.row.original?.task ? '/ ' + data.row.original?.task : null}
          </>
        ),
      },
      {
        Header: t('common:clockIn/Out'),
        width: 200,
        accessor: 'clock_in',
        Cell: (data: CellValue) => {
          return (
            <>
              {data.value?.local_time ? formatYearMonthDayTime(data.value?.local_time) : '- '}
              {' - '}
              <br />
              {data.row.original?.clock_out?.local_time
                ? formatYearMonthDayTime(data.row.original?.clock_out?.local_time)
                : ''}
            </>
          );
        },
      },
      ...(userStore?.companyInfo?.show_mileage
        ? [
            {
              Header: t('common:miles/km'),
              accessor: 'mileage',
              Cell: (data: CellValue) => <Text>{data.value ? formatDistanceUnit(+data.value) : 0}</Text>,
            },
          ]
        : []),

      {
        Header: t('common:duration'),
        accessor: 'duration',
        Cell: (data: CellValue) => <Text>{data.row.original?.payrolls?.duration || '- '}</Text>,
      },
      {
        Header: t('common:flaggedReason'),
        accessor: 'flagged_reason',
        width: 260,
      },
      ...(userStore?.companyInfo?.show_timesheet_notes
        ? [
            {
              Header: t('common:notes'),
              accessor: 'notes',
            },
          ]
        : []),
    ],
    [userStore, t]
  );

  return (
    <Box p="4">
      <Heading variant="h2" size="md" fontWeight="semibold" mb="4">
        {t('reports:filteredReport')}
      </Heading>
      {data?.attributes ? <ExportMenuFiltered attributes={data?.attributes} dateRange={dateRange} /> : null}
      <Table columns={columns} data={data?.timesheets || []} />
    </Box>
  );
};

export default FlaggedEntriesFilterTable;
